<script>
	import { getContext, onDestroy, createEventDispatcher } from 'svelte'
	import { styles } from '../library/scripts/styles'
	import { sort_blocks } from '../library/scripts/utils'
	import {
		storeFinishedContent,
		storeLinked,
		storeShowFinishedBlocks,
		storeUpdateSingle,
		storeShowCreateButtons,
	} from '../library/scripts/Store.svelte'

	import SingleCol from '../library/columLayouts/SingleCol.svelte'

	// remove linked sites from finished content
	const rmvBlock = (a, b) => {
		return a.filter((e) => {
			return !b.includes(e)
		})
	}

	//global variables
	const globals = getContext('globals')
	const fontXS = globals.fsXS
	const colorError = globals.colorError
	const colorMain = globals.adminColorMain
	const borderColor = globals.adminInputBorder

	//change title if is single update
	let updateSingle
	const stoUpdateSingle = storeUpdateSingle.subscribe((value) => {
		updateSingle = value
	})

	let linkedSites = []
	const stoLinked = storeLinked.subscribe((value) => {
		if (value) {
			if (updateSingle) {
				value.forEach((item) => {
					if (item === updateSingle) linkedSites = [item]
				})
			} else {
				linkedSites = value.sort()
				linkedSites = sort_blocks(linkedSites)
			}
		}
	})

	let finishedContent
	const stoFinishedContent = storeFinishedContent.subscribe((value) => {
		if (value) {
			if (updateSingle) {
				value.finishedBlocks.forEach((item) => {
					if (item === updateSingle) value.finishedBlocks = [item]
				})

				finishedContent = value.finishedBlocks
			} else {
				finishedContent = value.finishedBlocks.sort()
				finishedContent = sort_blocks(finishedContent)
			}
		}
	})
	$: finishedContent = rmvBlock(finishedContent, linkedSites)
	let showFinishedContent
	const stoShowFinishedContent = storeShowFinishedBlocks.subscribe((value) => {
		showFinishedContent = value
	})

	let dispatch = createEventDispatcher()
	const update_block = (b) => {
		if (b === 'social') storeShowCreateButtons.set(false)
		dispatch('onupdate', { blockName: b })
	}

	onDestroy(() => {
		stoFinishedContent
		stoShowFinishedContent
		stoUpdateSingle
		stoLinked
	})
</script>

<SingleCol column="100%">
	<div slot="column1">
		<div use:styles={{ colorMain, borderColor, fontXS }} class="container">
			{#if showFinishedContent && finishedContent.length > -1 && finishedContent.length !== 0}
				{#if !updateSingle}
					finished content - click to change
				{:else}
					click to update
				{/if}

				<div class="blocks_container">
					{#each finishedContent as block}
						<div
							class="blocks_created"
							on:click={() => update_block(block, null)}
							on:keydown={() => update_block(block, null)}
							use:styles={{ colorMain, fontXS, borderColor, colorError }}
						>
							{block}
						</div>
					{/each}
				</div>
			{/if}
			{#if showFinishedContent && linkedSites.length > -1 && linkedSites.length !== 0}
				<div style="margin-top:20px;">linked sites</div>
				<div class="blocks_container">
					{#each linkedSites as block}
						<div
							class="linked_sites"
							on:click={() => update_block(block, null)}
							on:keydown={() => update_block(block, null)}
							use:styles={{ colorMain, fontXS, colorMain, colorError }}
						>
							{block}
						</div>
					{/each}
				</div>
			{/if}
		</div>
	</div>
</SingleCol>

<style>
	.container {
		flex-direction: column;
		align-items: flex-start;
		justify-content: flex-start;
		height: clamp(30px, 8vw, 123px);
		color: var(--colorMain);
		width: 95vw;
		font-size: var(--fontXS);
		margin-top: 1%;
		padding-top: 2%;
		margin-bottom: 30px;
		border-top: 1px solid green;
	}

	.blocks_container {
		display: grid;
		grid-template-columns: 0.25fr 0.25fr 0.25fr 0.25fr 0.25fr;
		column-gap: 5px;
		row-gap: 5px;
		justify-content: flex-start;
		width: 100%;
		margin-top: 1%;
	}

	.blocks_created {
		display: flex;
		justify-content: center;
		align-items: center;
		font-size: var(--fontXS);
		color: var(--colorMain);
		margin-right: 2%;
		padding: 5px;
		border: 1px solid var(--borderColor);
		cursor: pointer;
	}

	.linked_sites {
		display: flex;
		justify-content: center;
		align-items: center;
		font-size: var(--fontXS);
		color: var(--colorMain);
		margin-right: 2%;
		padding: 5px;
		border: 1px solid var(--colorError);
		cursor: pointer;
	}

	.linked_sites:hover {
		color: var(--colorError);
	}

	.blocks_created:hover {
		color: var(--colorError);
	}
</style>
